import { __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import UserAvatar from '../User/Avatar/index';
import UserLink from '../User/Link/index';
import s from './ProfileIdentityMobile.scss';
var ProfileIdentityMobile = /** @class */ (function (_super) {
    __extends(ProfileIdentityMobile, _super);
    function ProfileIdentityMobile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProfileIdentityMobile.prototype.render = function () {
        var _a = this.props, className = _a.className, user = _a.user, tagline = _a.tagline, statsComponent = _a.statsComponent;
        return (React.createElement("div", { className: classnames(s['root'], className) },
            React.createElement(UserAvatar, { size: 80, user: user, className: s['user-avatar'] }),
            React.createElement("div", { className: s['user-details'] },
                React.createElement("h1", { className: s['user-link'] },
                    React.createElement(UserLink, { className: s['user-link-text'], symbolClassName: s['user-link-icon'], user: user })),
                tagline && React.createElement("div", { className: s['user-label'] }, tagline),
                statsComponent)));
    };
    return ProfileIdentityMobile;
}(React.PureComponent));
export { ProfileIdentityMobile };
export default ProfileIdentityMobile;
//# sourceMappingURL=ProfileIdentityMobile.js.map